
angular.module('trainerWebApp.resources')
  .factory('shopifyResource', ['$resource', '$route', 'errorHandler', function ($resource, $route, errorHandler) {

    var shopifyResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/shopify/:courseId');
    var courseRemovalResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/shopify/:sid/remove');
    var courseResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/shopify/courses');
    var courseUpdateResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/shopify/update');

    shopifyResource.prototype.initShopify = function initShopify(payloadObj, resultCb, errorCb) {
      return shopifyResource.save({}, payloadObj, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    shopifyResource.prototype.load = function load(resultCb, errorCb) {
      return shopifyResource.get(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    shopifyResource.prototype.allCourses = function allCourses(resultCb, errorCb) {
      return courseResource.get(resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    shopifyResource.prototype.delist = function delist(params, resultCb, errorCb) {
      return courseRemovalResource.save({sid: params.sid}, params, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    shopifyResource.prototype.addItems = function listCourses(params, resultCb, errorCb) {
      return courseResource.save({}, params, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    shopifyResource.prototype.updateCourses = function updateCourses(params, resultCb, errorCb) {
      return courseUpdateResource.save({}, params, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new shopifyResource;
  }]
);
